<template>
  <div>
    <q-toggle v-model="hasTitle" color="pink" label="Afficher le nom des points" @update:model-value="start" />

    <div id="mainContainer" class="mainContainer animate__animated animate__zoomIn">
      <div
        ref="navigationPreviewRef"
        class="navigation-preview"
        :class="{ 'navigation-preview--hidden': popup }"
      >
        <canvas ref="canvasRef" width="500"></canvas>
      </div>
      
      <div class="popup" v-if="popup">
        <q-dialog v-model="popup" allow-focus-outside seamless>

        <q-card class="column" :style="getPopupBackgroundStyle">
          <div class="preview-scale-wrap">
          <q-card-section class="row items-center q-pb-none">
            <q-btn icon="close" flat round dense v-close-popup @click="closeAll()" />
          </q-card-section>
         

          <q-card-section class="col q-pt-none">
            <div v-for="(block, index) in blocks1" :key="index"
              :style="{ top: (block.top ) + 'px', left: block.left + 'px' }" class="block">
              <div class="media-container"
                :class="{ 'has-associated': block.associatedResources }"
                :style="{ width: `${block.width}px`, height: `${block.height}px`, position: relative }">
                <transition appear :enter-active-class="block.animation">
                  <div v-show="block.animation || block.animation2" :key="index"
                    :class="block.animation2 ? block.animation2 : ''">
                    <img v-if="block.animation != 'squareImg' && isImage(block.name)" :src="block.imgSrc"
                      alt="Block Image" class="img" :style="getStyle(block)"
                      @click="() => { showStyleComponenent(block) }" />
                    <SquareImg v-else-if="block.animation == 'squareImg' && isImage(block.name)" :blockDatas="block"
                      @click="() => { showStyleComponenent(block) }" />
                    <video v-else-if="isVideo(block.name)" :src="block.imgSrc" :style="getRotationStyleVideo(block)"
                      controls class="video-container"></video>
                    <audio v-else-if="isAudio(block.name)" :src="block.imgSrc" controls></audio>
                    <q-icon v-if="block.associatedResources && block.animation != 'squareImg'"
                      class="associated-resources-icon" name="new_releases" color="orange"></q-icon>
                  </div>
                </transition>
              </div>
            </div>

            <div v-for="(block2, index) in blocks2" :key="index + 100"
              class="block cartel animate__animated animate__zoomIn"
              :style="{ top: (block2.top ) + 'px', left: block2.left + 'px' }">
              {{ block2.text }}
            </div>
            
            <!-- Textes personnalisés -->
            <div v-for="(textBlock, index) in textBlocks" :key="'text-'+index" 
              class="text-block"
              :style="getTextBlockStyle(textBlock)">
              <div v-html="textBlock.content"></div>
            </div>
          </q-card-section>
          </div>
        </q-card>
        <div v-if="negatifSlider" class="styleElements">
          <NegatifSlider :blockDatas="blockSliderDatas" @closeSlider="closeSlider()" />
        </div>
        <div v-if="comicOverlay">
          <ComicsOverlay :block="comicsDatas" />
        </div>
        <div>
          <Carousel3D v-if="carousel3D" :blockDatas="blockCarouselDatas" @closeCarousel3D="closeCarousel3D" />
        </div>
        <div>
          <FlipBook v-if="flipBook" :blockDatas="blockSliderDatas" @closeFlipBook="closeFlipBook" />
        </div>
        <div>
          <Diaporama v-if="diaporama" :blockDatas="blockDiaporamaDatas" @closeDiaporama="closeDiaporama" />
        </div>
        <div>
          <Mosaique v-if="mosaique" :blockDatas="blockMosaiqueDatas" @closeMosaique="closeMosaique" />
        </div>
        <div>
          <Pellicule v-if="pellicule" :blockDatas="blockPelliculeDatas" @closePellicule="closePellicule" />
        </div>
        <div>
          <CoverflowCarousel v-if="coverflow" :blockDatas="blockCoverflowDatas" @closeCoverflow="closeCoverflow" />
        </div>
        <div>
          <AvantApres v-if="avantApres" :blockDatas="blockAvantApresDatas" @closeAvantApres="closeAvantApres" />
        </div>
        <div>
          <MusicNotes v-if="musicNotes" />
        </div>
        <div>
          <Scroll v-if="scroll" :blockScrollDatas="blockScrollDatas" @closeScroll="closeScroll" />
        </div>
        <div>
          <VideoComponent v-if="video" :blockVideoDatas="blockVideoDatas" @closeVideo="closeVideo" />
        </div>
        <div>
          <ImageAudio v-if="imageAudio" :blockImageAudioDatas="blockImageAudioDatas" @closeImageAudio="closeImageAudio" />
        </div>
        <div>
          <DocxViewer 
            v-if="docxViewer" 
            :docxResource="blockDocxData" 
            @closeDocxViewer="closeDocxViewer" 
            @closeAllDialogs="closeAllDialogs" />
        </div>
      </q-dialog>
      </div>
    </div>

  </div>
</template>
  
<script>
import { ref, onMounted, watch, computed, provide } from "vue";
//import { useRoute } from "vue-router";
import { useStore } from 'vuex';
import axios from "axios";
import Konva from "konva";
import NegatifSlider from "../components/NegatifSlider.vue";
import ComicsOverlay from "../components/ComicsOverlay.vue";
import Carousel3D from "../components/Carousel3D.vue";
import FlipBook from "../components/FlipBook.vue";
import SquareImg from "../components/SquareImg.vue";
import MusicNotes from "../components/MusicNotes.vue";
import Scroll from "../components/Scroll.vue";
import VideoComponent from "../components/Video.vue";
import ImageAudio from "./ImageAudio.vue";
import DocxViewer from "../components/DocxViewer.vue";
import Diaporama from "../components/Diaporama.vue";
import Mosaique from "../components/Mosaique.vue";
import Pellicule from "../components/Pellicule.vue";
import CoverflowCarousel from "../components/CoverflowCarousel.vue";
import AvantApres from "../components/AvantApres.vue";
import { useExhibitStyle } from "../composables/useExhibitStyle";
export default {
  components: {
    NegatifSlider,
    ComicsOverlay,
    Carousel3D,
    FlipBook,
    SquareImg,
    MusicNotes,
    Scroll,
    VideoComponent,
    ImageAudio,
    DocxViewer,
    Diaporama,
    Mosaique,
    Pellicule,
    CoverflowCarousel,
    AvantApres
  },
  props: {
    exhibitIdBis: {
      type: String,
      default: ""
    },
    selectedPointId: {
      type: Number
    }
  },
  setup(props) {
    //const route = useRoute();
    const store = useStore();
    // Fond configurable de l'overlay (mêmes règles que template_6) : les composants
    // d'overlay l'injectent via useOverlayBg().
    let overlayBg = ref({ color: null, imageSrc: null });
    provide('overlayBg', overlayBg);
    const { style: charte, hasStyle: hasCharte, load: loadCharte } = useExhibitStyle(store.state.exhibitId ?? props.exhibitIdBis);
    let exhibitId = ref();
    let backgroundImg = ref();
    let resources = ref();
    let backgroundFile = ref();
    let canvasRef = ref(null);
    let navigationPreviewRef = ref(null);
    let mainResourceId = ref();
    let points = ref([]);
    var stage;
    var layer;
    let imgWidth = ref();
    let imgHeight = ref();
    let popup = ref(false);
    let blocksDatas = ref();
    let blocks1 = ref([]);
    let blocks2 = ref([]);
    let currentPointId = ref();
    let negatifSlider = ref(false);
    let blockSliderDatas = ref();
    let comicOverlay = ref();
    let carousel3D = ref(false);
    let flipBook = ref(false);
    let squareImg = ref(false);
    let showBlock = ref(true);
    let musicNotes = ref(false);
    let comicsDatas = ref();
    let blockCarouselDatas = ref();
    let scroll = ref(false);
    let blockScrollDatas = ref();
    let homeImage = ref();
    let hasHomeImage = ref(false);
    let homeResource = ref();
    let video = ref(false);
    let blockVideoDatas = ref();
    let animations = ref(false);
    let showBlockDelay = ref(false);
    let mainResource = ref();
    let hasTitle = ref(true);
    let imageAudio = ref(false);
    let blockImageAudioDatas = ref();
    let squareImgData = ref();
    let titleColor = ref();
    let titleSize = ref();
    let textBlocks = ref([]);
    let docxDatas = ref();
    let docxViewer = ref(false);
    let blockDocxData = ref(null);
    let diaporama = ref(false);
    let blockDiaporamaDatas = ref();
    let mosaique = ref(false);
    let blockMosaiqueDatas = ref();
    let pellicule = ref(false);
    let blockPelliculeDatas = ref();
    let coverflow = ref(false);
    let blockCoverflowDatas = ref();
    let avantApres = ref(false);
    let blockAvantApresDatas = ref();
    let popupBackgroundImage = ref(null);
    let popupBackgroundColorValue = ref(null);
    let pointSelectedFromStore = computed(() => {
      return store.state.pointSelected;
    })
    const start = async () => {
      exhibitId.value = store.state.exhibitId;
      if (exhibitId.value == undefined) {
        exhibitId.value = props.exhibitIdBis;
      }
      await loadCharte();
      await getMainResource();
      await getResources();
      if (mainResource.value) {
        await getFile(mainResource.value.name);
        //const base64data = await blobToData(backgroundFile.value, mainResource.value.name);
        backgroundImg.value = backgroundFile.value;
      }
      await drawImage();
      await getPoints();
      await showPoints();
      await fetchPointColors();

      await getAnimations();
    };
    const getResources = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resources`;
        let body = {
          exhibitId: exhibitId.value,
        };
        let response = await axios.post(url, body);
        let results = response.data;
        resources.value = results;
      } catch (error) {
        console.log(error);
      }
    };

    const fetchPointColors = async () => {
      const fallbackBg = hasCharte.value ? charte.value.bg_color : null;
      try {
        const url = `${process.env.VUE_APP_BASEURL}/intermediateColor/${currentPointId.value}`;
        const response = await axios.get(url);
        if (response.data && response.data[0]) {
          popupBackgroundColorValue.value = response.data[0].background_color || fallbackBg;
          titleColor.value = response.data[0].text_color;
          titleSize.value = response.data[0].text_size;
        } else {
          // Réinitialiser si aucune donnée n'est trouvée
          popupBackgroundColorValue.value = fallbackBg;
          titleColor.value = null;
          titleSize.value = null;
        }
      } catch (error) {
        console.log('Erreur lors de la récupération des couleurs du point:', error);
        // Réinitialiser en cas d'erreur
        popupBackgroundColorValue.value = fallbackBg;
        titleColor.value = null;
        titleSize.value = null;
      }
    }

    /* async function blobToData(blob, name) {
       return new Promise((resolve) => {
         const reader = new FileReader();
         reader.onloadend = () => {
           let content = null;
           let width = null;
           let height = null;
           const extension = name.split(".").pop().toLowerCase();
           if (["jpg", "jpeg", "png", "gif", "bmp"].includes(extension)) {
             const image = new Image();
             image.src = reader.result;
             image.onload = function () {
               const aspectRatio = image.width / image.height;
               width = Math.min(image.width, 200);
               height = width / aspectRatio;
               content = {
                 url: image.src,
                 width: width,
                 height: height
               };
               resolve(content);
             };
           } else if (["mp4", "webm", "avi", "mov", "mkv"].includes(extension)) {
             const video = document.createElement("video");
             video.src = URL.createObjectURL(blob);
             video.addEventListener('loadedmetadata', function () {
               const aspectRatio = video.videoWidth / video.videoHeight;
               width = Math.min(video.videoWidth, 300);
               height = width / aspectRatio;
 
               content = {
                 url: video.src,
                 width: width,
                 height: height
               };
               resolve(content);
             })
           } else if (["mp3", "wav", "ogg", "m4a"].includes(extension)) {
             content = {
               url: URL.createObjectURL(blob),
               width: null,
               height: null
             };
             resolve(content);
           } else {
             resolve(content);
           }
         };
         reader.readAsDataURL(blob);
       });
     }
     */
    const getFile = async (name) => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${name}`;
        let response = await axios.get(url);
        backgroundFile.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const getStyle = (block) => {
      return {
        width: `${block.width}px`,
        height: `${block.height}px`,
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        boxShadow: block.boxShadow

      };
    }

    const getResourcesFromPoints = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resourcesFromPointWithAssociations/${currentPointId.value}`;
        let response = await axios.get(url);
        blocksDatas.value = response.data;
        await loadSavedTexts();
      } catch (error) {
        console.log(error);
      }
    }

    // Charger les textes enregistrés pour ce point
    const loadSavedTexts = async () => {
      try {
        // Utiliser l'endpoint existant pour récupérer les textes par point_id
        const url = `${process.env.VUE_APP_BASEURL}/custom-texts/point/${currentPointId.value}`;
        const response = await axios.get(url);
        textBlocks.value = {}
        if (response.data && response.data.length) {
          // Transformer les données reçues au format utilisé par le composant
          textBlocks.value = response.data.map(text => ({
            id: text.id,
            content: text.content,
            top: text.position_top,
            left: text.position_left,
            width: text.width,
            height: text.height,
            fontFamily: text.font_family,
            fontSize: text.font_size,
            color: text.color,
            backgroundColor: text.background_color,
            borderWidth: text.border_width,
            borderStyle: text.border_style,
            borderColor: text.border_color,
            borderRadius: text.border_radius,
            boxShadow: text.box_shadow
          }));
        }
      } catch (error) {
        console.log(error);
      }
    };
    
    const getTextBlockStyle = (block) => {
      return {
        position: 'absolute',
        top: (block.top) + 'px',
        left: block.left + 'px',
        width: block.width ? block.width + 'px' : 'auto',
        height: block.height ? block.height + 'px' : 'auto',
        fontFamily: block.fontFamily || (hasCharte.value ? charte.value.text_font : 'Arial'),
        fontSize: (block.fontSize || (hasCharte.value ? charte.value.text_size : 16)) + 'px',
        color: block.color || (hasCharte.value ? charte.value.text_color : '#000000'),
        backgroundColor: block.backgroundColor || 'transparent',
        padding: '10px',
        borderWidth: block.borderWidth + 'px' || '0px',
        borderStyle: block.borderStyle || 'solid',
        borderColor: block.borderColor || 'transparent',
        borderRadius: block.borderRadius + 'px' || '0px',
        boxShadow: block.boxShadow || 'none'
      };
    };

    const drawImage = () => {
      return new Promise((resolve, reject) => {
        var imageObj = new Image();
        imageObj.src = backgroundFile.value;
        imageObj.onload = function () {
          if (!navigationPreviewRef.value) {
            reject(new Error("Conteneur de prévisualisation introuvable"));
            return;
          }

          if (stage) {
            stage.destroy();
          }

          const maxWidth = 500;
          const scale = maxWidth / imageObj.width;
          stage = new Konva.Stage({
            container: navigationPreviewRef.value,
            width: maxWidth,
            height: imageObj.height * scale,
          });
          imgWidth.value = maxWidth;
          imgHeight.value = imageObj.height * scale;
          layer = new Konva.Layer();
          stage.add(layer);
          var image = new Konva.Image({
            x: 0,
            y: 0,
            image: imageObj,
            width: maxWidth,
            height: imageObj.height * scale,
            scaleX: 1,
            scaleY: 1,
          });
          layer.add(image);
          layer.draw();
          resolve();
        };
        imageObj.onerror = function() {
          console.error("Erreur lors du chargement de l'image de fond pour Konva.");
          reject(new Error("Erreur chargement image Konva"));
        }
      });
    };

    const getRotationStyleVideo = (block) => {
      return {
        transform: `rotate(${block.angle}deg)`,
        borderRadius: block.radius + 'px',
        border: `solid ${block.borderWidth}px ${block.borderColor}`,
        objectFit: 'contain',
        width: `${block.width}px`,
        height: `${block.height}px`,
        boxShadow: block.boxShadow

      };
    };



    const getMainResource = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/mainResource/${exhibitId.value}`;
        let response = await axios.get(url);
        if (response.data.length > 0) {
          mainResourceId.value = response.data[0].main_resource_id;
          mainResource.value = response.data[0];
        }

      } catch (error) {
        console.log(error)
      }
    }




    const exitHomePage = async () => {
      hasHomeImage.value = false;
      await drawImage();
      await getPoints();
      await showPoints();
    }


    /*const computeMargins = () => {
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      const marginLeft = (windowWidth - 1400) / 2;
      const marginTop = (windowHeight - 700) / 2;

      return { marginLeft, marginTop };
    }*/



    const showBlocks = async () => {
      try {
        blocks1.value.splice(0);
        blocks2.value.length = 0;
        //const { marginLeft, marginTop } = computeMargins();

        var originalExpoWidth = window.innerWidth;
        for (var data of blocksDatas.value) {
          let url = `${process.env.VUE_APP_BASEURL}/s3Resource/${data.name}`;
          let response = await axios.get(url);
          //const base64data = await blobToData(response.data, data.name);
          let url2 = `${process.env.VUE_APP_BASEURL}/position/${data.resource_id}`;
          let response2 = await axios.get(url2);
          if (response2.data.length > 1) {
            response2.data = response2.data.filter(element => element.point_id == currentPointId.value)
          }
          let url3 = `${process.env.VUE_APP_BASEURL}/style/${data.resource_id}/${data.point_id}`;
          let response3 = await axios.get(url3);
          let style = response3.data[0] ? response3.data[0].style : null;
          var obj = {};
          obj.bg_color = response3.data[0] ? response3.data[0].bg_color : null;
          obj.bg_image_id = response3.data[0] ? response3.data[0].bg_image_id : null;
          if (response2.data[0]) {
            obj.top = response2.data[0].y;
            obj.left = response2.data[0].x;
            obj.width = response2.data[0].width;
            obj.height = response2.data[0].height;
            obj.angle = response2.data[0].angle;
            obj.radius = response2.data[0] ? response2.data[0].border_radius : 10;
            obj.borderColor = response2.data[0] ? response2.data[0].border_color : "#ffffff";
            obj.borderWidth = response2.data[0] ? response2.data[0].border_width : 0;
            obj.boxShadow = response2.data[0] ? response2.data[0].shadow : "0px 0px 0px #000000";

          } else {
            obj.top = window.innerHeight / 2;
            obj.left = 5 / originalExpoWidth * 100;
            obj.width = 100;
            obj.height = 100;
            obj.angle = 0;
          }
          obj.resourceId = data.resource_id;
          obj.name = data.name;
          obj.imgSrc = response.data;
          obj.associatedResources = data.associatedResources;
          obj.style = style;
          obj.title = data.title;

          blocks1.value.push(obj);
        }
        for (var data2 of blocksDatas.value) {
          let url3 = `${process.env.VUE_APP_BASEURL}/position/${data2.resource_id}`;
          let response3 = await axios.get(url3);
          if (response3.data.length > 1) {
            response3.data = response3.data.filter(element => element.point_id == currentPointId.value)
          }
          var obj2 = {};
          if (response3.data[0]) {
            obj2.top = response3.data[0].description_y;
            obj2.left = response3.data[0].description_x;
            obj2.text = response3.data[0].description;
          } else {
            obj2.top = 0;
            obj2.left = 0;
            obj2.text = "";
          }
          obj2.resourceId = data.resource_id;
          if (obj2.text != null && obj2.text != undefined && obj2.text != "") {
            blocks2.value.push(obj2);
          }
        }
        showAnimations();

        blocks1.value.map(block => {
          showBlockStyle(block)
        })
      } catch (error) {
        console.log(error);
      }
    };


    const loadImage = (imageUrl) => {
      return new Promise((resolve, reject) => {
        const imageObj = new Image();
        imageObj.onload = () => resolve(imageObj);
        imageObj.onerror = reject;
        imageObj.src = imageUrl;
      });
    };

    const getResourceImage = async (resourceId) => {
      if (!resourceId) return null;
      const url = `${process.env.VUE_APP_BASEURL}/resourceData/${resourceId}`;
      const response = await axios.get(url);
      if (!response.data || !response.data[0]) return null;
      const url2 = `${process.env.VUE_APP_BASEURL}/s3Resource/${response.data[0].name}`;
      const response2 = await axios.get(url2);
      return loadImage(response2.data);
    };

    const estimateTextWidth = (text, fontSize, fontFamily) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px ${fontFamily}`;
      return ctx.measureText(text || '').width;
    };

    const showPoints = async () => {
      await new Promise(r => setTimeout(r, 1000));

      const maxWidth = 500;

      let promises = points.value.map(async (point) => {
        const height = imgHeight.value * (maxWidth / imgWidth.value);
        const x_new = (point.x / maxWidth) * imgWidth.value;
        const y_new = (point.y / height) * imgHeight.value;
        const pointSize = point.size || 20;
        const pointColor = point.color || '#000000';
        const labelSize = point.label_size || 16;
        const labelFont = point.label_font || 'Arial';
        const shouldShowTitle = hasTitle.value && point.visibility !== false && point.visibility !== 0;

        let imageObjForShape = null;
        let textY = y_new - pointSize - labelSize - 8;

        try {
          if (point.resource_id) {
            const imageObj = await getResourceImage(point.resource_id);

            if (point.image_position === 'inside') {
              imageObjForShape = imageObj;
            } else if (imageObj) {
              let imageX = x_new;
              let imageY = y_new;

              const maxDimImg = 50;
              const imgRatio = imageObj.width / imageObj.height;
              const imgW = imgRatio >= 1 ? maxDimImg : maxDimImg * imgRatio;
              const imgH = imgRatio >= 1 ? maxDimImg / imgRatio : maxDimImg;
              const halfImageWidth = imgW / 2;
              const halfImageHeight = imgH / 2;

              switch (point.image_position) {
                case 'top':
                  imageY = y_new - pointSize - imgH - 15;
                  imageX -= halfImageWidth;
                  textY = y_new + pointSize + 15;
                  break;
                case 'right':
                  imageX = x_new + pointSize + 10;
                  imageY -= halfImageHeight;
                  break;
                case 'bottom':
                  imageY = y_new + pointSize + 10;
                  imageX -= halfImageWidth;
                  break;
                case 'left':
                  imageX = x_new - pointSize - imgW - 10;
                  imageY -= halfImageHeight;
                  break;
                default:
                  break;
              }

              const konvaImage = new Konva.Image({
                x: imageX,
                y: imageY,
                image: imageObj,
                width: imgW,
                height: imgH,
                stroke: 'white',
                strokeWidth: 2,
                shadowColor: 'black',
                shadowBlur: 10,
                shadowOffsetX: 3,
                shadowOffsetY: 3,
                shadowOpacity: 0.6,
                filters: [Konva.Filters.Contrast],
                contrast: 10
              });

              layer.add(konvaImage);
            }
          }

          await addCircle(
            x_new,
            y_new,
            point.point_id,
            pointSize,
            pointColor,
            imageObjForShape,
            point.shape,
            point.shape_image_id,
            point.hover_animation
          );

          if (shouldShowTitle) {
            const textWidth = estimateTextWidth(point.name, labelSize, labelFont);
            const text = new Konva.Text({
              x: x_new - (textWidth / 2),
              y: textY,
              text: point.name,
              fontSize: labelSize,
              fontFamily: labelFont,
              fill: point.label_color || 'white',
              shadowColor: 'black',
              shadowBlur: 4,
              shadowOffsetX: 2,
              shadowOffsetY: 2,
              shadowOpacity: 0.7,
              align: 'center'
            });
            layer.add(text);
            text.moveToTop();
          }
        } catch (error) {
          console.log('Erreur lors du rendu du point de prévisualisation:', point.point_id, error);
        }
      });

      await Promise.all(promises);

      layer.draw();
      layer.moveToTop()
      stage.on('click', function () {
        var pos = stage.getPointerPosition();
        var shape = stage.getIntersection(pos);
        if (shape) {
          console.log('Vous avez cliqué sur un ' + shape.className);
          console.log(pos)
        }
      });
    };
    const addCircle = async (x, y, pointId, size, color, imageObj = null, pointShape = 'circle', shapeImageId = null, hoverAnimation = false) => {
      const currentShape = pointShape || 'circle';
      let shapeNode;

      const addLift = (node) => {
        if (!hoverAnimation) return;
        node.on('mouseenter', () => {
          node.moveToTop();
          node.to({ scaleX: 1.18, scaleY: 1.18, duration: 0.12 });
        });
        node.on('mouseout', () => {
          node.to({ scaleX: 1, scaleY: 1, duration: 0.12 });
        });
      };

      const handleInteraction = async (e) => {
        console.log('🎯 HandleInteraction déclenchée pour point:', pointId, e);

        // ⚠️ IMPORTANT: Réinitialiser l'image de fond au changement de point
        popupBackgroundImage.value = null;
        console.log('🧹 Image de fond réinitialisée (handleInteraction)');

        currentPointId.value = pointId;
        await fetchPointColors();
        popup.value = true;
        await getResourcesFromPoints();
        await showBlocks();
        console.log('🖼️ Démarrage chargement image de fond...');
        await loadPopupBackgroundImage(); // Charger l'image de fond du popup
        console.log('✅ Interaction complétée');
      };

      if (currentShape === 'square') {
        const rectConfig = {
          x: x - size,
          y: y - size,
          width: size * 2,
          height: size * 2,
          fill: imageObj ? null : color,
          stroke: "#ffffff",
          strokeWidth: 3,
          shadowColor: 'rgba(0, 0, 0, 0.3)',
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsetY: 2,
          shadowOpacity: 1,
        };
        if (imageObj) {
          const scale = (size * 2) / Math.max(imageObj.width, imageObj.height);
          rectConfig.fillPatternImage = imageObj;
          rectConfig.fillPatternScaleX = scale;
          rectConfig.fillPatternScaleY = scale;
          rectConfig.fillPatternOffset = {
            x: imageObj.width / 2,
            y: imageObj.height / 2
          };
          rectConfig.fillPatternRepeat = 'no-repeat';
          layer.add(new Konva.Rect({
            x: x - size,
            y: y - size,
            width: size * 2,
            height: size * 2,
            fill: color
          }));
        }
        shapeNode = new Konva.Rect(rectConfig);
      } else if (currentShape === 'image' && shapeImageId) {
        const shapeImgObj = await getResourceImage(shapeImageId);
        if (shapeImgObj) {
          const maxDim = size * 2;
          const ratio = shapeImgObj.width / shapeImgObj.height;
          let width;
          let height;
          if (ratio >= 1) {
            width = maxDim;
            height = maxDim / ratio;
          } else {
            height = maxDim;
            width = maxDim * ratio;
          }
          shapeNode = new Konva.Image({
            x,
            y,
            offsetX: width / 2,
            offsetY: height / 2,
            image: shapeImgObj,
            width,
            height,
          });
        }
      }

      if (!shapeNode) {
        const circleConfig = {
          x: x,
          y: y,
          radius: size,
          fill: imageObj ? null : color,
          stroke: "#ffffff",
          strokeWidth: 3,
          shadowColor: 'rgba(0, 0, 0, 0.3)',
          shadowBlur: 5,
          shadowOffsetX: 0,
          shadowOffsetY: 2,
          shadowOpacity: 1,

        }
        if (imageObj) {
          const scale = (size * 2) / Math.max(imageObj.width, imageObj.height);
          circleConfig.fillPatternImage = imageObj;
          circleConfig.fillPatternScaleX = scale;
          circleConfig.fillPatternScaleY = scale;
          circleConfig.fillPatternOffset = {
            x: imageObj.width / 2,
            y: imageObj.height / 2
          };
          circleConfig.fillPatternRepeat = 'no-repeat';
          layer.add(new Konva.Circle({
            x: x,
            y: y,
            radius: size,
            fill: color
          }));
        }
        shapeNode = new Konva.Circle(circleConfig);
      }

      layer.add(shapeNode);

      // Ajout des gestionnaires d'événements pour les clics et les appuis
      shapeNode.on('mouseenter', () => {
        stage.container().style.cursor = 'pointer';
      });

      shapeNode.on('mouseout', () => {
        stage.container().style.cursor = 'default';
      });

      // Ajout des gestionnaires d'événements pour les clics et les appuis
      shapeNode.on("click", handleInteraction);
      shapeNode.on("tap", handleInteraction);
      addLift(shapeNode);
      shapeNode.moveToTop();

    };
    const getPoints = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/points/${mainResourceId.value}`;
        let response = await axios.get(url);
        points.value = response.data;
      } catch (error) {
        console.log(error);
      }
    };

    const showBlockStyle = (block) => {
      blockSliderDatas.value = block
      if (block.style == "comics") {
        comicOverlay.value = true
        comicsDatas.value = block;
      }
      if (block.style == "musicNote") {
        musicNotes.value = true
      }
    }

    const loadOverlayBgImage = async (id) => {
      if (!id) return;
      try {
        const r1 = await axios.get(`${process.env.VUE_APP_BASEURL}/resourceData/${id}`);
        const name = r1.data && r1.data[0] && r1.data[0].name;
        if (!name) return;
        const r2 = await axios.get(`${process.env.VUE_APP_BASEURL}/s3Resource/${name}`);
        overlayBg.value = { ...overlayBg.value, imageSrc: r2.data };
      } catch (e) { console.log('loadOverlayBgImage', e); }
    };

    const showStyleComponenent = (block) => {
      overlayBg.value = { color: block.bg_color || null, imageSrc: null };
      if (block.bg_image_id) loadOverlayBgImage(block.bg_image_id);
      if (block.associatedResources && block.style == "negatifSlider") {
        negatifSlider.value = true;
      }
      if (block.associatedResources && block.style == "carousel3D") {
        carousel3D.value = true;
        blockCarouselDatas.value = block
      }
      if (block.associatedResources && block.style == "scroll") {
        scroll.value = true;
        blockScrollDatas.value = block
      }
      if (block.associatedResources && block.style == "flipBook") {
        flipBook.value = true;
      }
      if (block.associatedResources && block.style == "video") {
        video.value = true;
        blockVideoDatas.value = block
      }
      if (block.associatedResources && block.style == "imageAudio") {
        imageAudio.value = true;
        blockImageAudioDatas.value = block
      }
      if (block.style == "docx") {
        blockDocxData.value = block;
        docxViewer.value = true;
      }
      if (block.associatedResources && block.style == "diaporama") {
        diaporama.value = true;
        blockDiaporamaDatas.value = block
      }
      if (block.associatedResources && block.style == "mosaique") {
        mosaique.value = true;
        blockMosaiqueDatas.value = block
      }
      if (block.associatedResources && block.style == "pellicule") {
        pellicule.value = true;
        blockPelliculeDatas.value = block
      }
      if (block.associatedResources && block.style == "coverflow") {
        coverflow.value = true;
        blockCoverflowDatas.value = block
      }
      if (block.associatedResources && block.style == "avantApres") {
        avantApres.value = true;
        blockAvantApresDatas.value = block
      }

      blockSliderDatas.value = block;
    }

    const showAnimations = async () => {
      let newBlocks1 = [...blocks1.value]; // Création d'une nouvelle instance du tableau
      for (let block of newBlocks1) {
        if (Array.isArray(animations.value) && animations.value.some(animation => animation.resource_id == block.resourceId && animation.point_id == currentPointId.value )) {
          let animation = animations.value.find(animation => animation.resource_id == block.resourceId && animation.point_id == currentPointId.value)
          let animationString;
          if (animation.animation === "spin" || animation.animation === "slide" || animation.animation === "pulse" || animation.animation === "swingRotate" || animation.animation === "verticalBounce") {
            block['animation2'] = animation.animation
          } else if(animation.animation == "squareImg"){
            block['animation']= "squareImg";
            block['animationSpeed'] = animation.speed || "";
            block['animationDelay'] = animation.delay || "";
          }  else if(animation.animation == "musicNote"){
            musicNotes.value = true
            block['animation']= "musicNote";
          }else {
            animationString = 'animate__animated animate__' + animation.animation + " animate__slower";
            block['animation'] = animationString;
          }
        } else {
          block['animation'] = 'animate__animated animate__zoomIn';
        }
      }
      blocks1.value = newBlocks1; // Assignation du nouveau tableau à blocks1.value
    }


    const closeAll = () => {
      comicOverlay.value = false;
      squareImg.value = false;
      musicNotes = false;
      blocks1.value.splice(0);
      blocks2.value = [];
    }

    const closeCarousel3D = () => {
      carousel3D.value = false;
    }

    const closeSlider = () => {
      negatifSlider.value = false;
    }

    const closeScroll = () => {
      scroll.value = false
    }

    const closeFlipBook = () => {
      flipBook.value = false;
    }

    const closeDiaporama = () => {
      diaporama.value = false;
    }

    const closeMosaique = () => {
      mosaique.value = false;
    }

    const closePellicule = () => {
      pellicule.value = false;
    }

    const closeCoverflow = () => {
      coverflow.value = false;
    }

    const closeAvantApres = () => {
      avantApres.value = false;
    }

    const closeImageAudio = () => {
      imageAudio.value = false;
    }

    const closeVideo = () => {
      video.value = false;
      blockVideoDatas.value = {};
    }

    function isImage(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension);
    }

    function isVideo(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp4", "webm", "avi", "mov", "mkv"].includes(extension);
    }

    function isAudio(name) {
      const extension = name.split(".").pop().toLowerCase();
      return ["mp3", "wav", "ogg", "m4a"].includes(extension);
    }

    const getAnimations = async () => {
      try {
        let url = `${process.env.VUE_APP_BASEURL}/resource_animation/${exhibitId.value}`;
        let response = await axios.get(url);
        animations.value = response.data;

        // S'assurer que speed et delay sont accessibles (colonnes animation_speed / animation_delay)
        if (animations.value && animations.value.length > 0) {
          animations.value = animations.value.map(animation => {
            if (!animation.speed && animation.animation_speed) {
              animation.speed = animation.animation_speed;
            }
            if (!animation.delay && animation.animation_delay) {
              animation.delay = animation.animation_delay;
            }
            return animation;
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    const showPopup = async (pointId) => {
      console.log('🎯 ShowPopup déclenchée pour point:', pointId);

      // ⚠️ IMPORTANT: Réinitialiser l'image de fond au changement de point
      popupBackgroundImage.value = null;
      console.log('🧹 Image de fond réinitialisée pour nouveau point');

      squareImg.value = false;
      currentPointId.value = pointId;
      await fetchPointColors();
      popup.value = true;

      // Recharger la liste des animations pour refléter d'éventuels changements
      await getAnimations();

      await getResourcesFromPoints();
      await showBlocks();
      console.log('🖼️ Démarrage chargement image de fond (showPopup)...');
      await loadPopupBackgroundImage(); // ⚠️ Cette ligne était manquante !
      console.log('✅ ShowPopup complétée');
    }

    const getTitleStyle = () => {
      return {
        width: '100%',
        marginBottom: 'none',
        textAlign: 'center',
        color: titleColor.value,
        fontSize: titleSize.value + "px",
      }
    }

    // Fonction pour charger l'image de fond du popup
    const loadPopupBackgroundImage = async () => {
      try {
        console.log('🔍 Chargement image de fond pour point:', currentPointId.value);

        // ⚠️ IMPORTANT: Réinitialiser l'image précédente
        popupBackgroundImage.value = null;
        console.log('🧹 Image précédente effacée');

        const url = `${process.env.VUE_APP_BASEURL}/pointBackgroundImage/point/${currentPointId.value}`;
        const response = await axios.get(url);
        console.log('📡 Réponse API pointBackgroundImage:', response.data);

        // Extraire l'ID de la ressource à partir de la réponse
        const resourceId = response.data?.resource_id ||
                        response.data?.background_image_id ||
                        (response.data[0] ? response.data[0].resource_id : null);

        console.log('🔑 ResourceId trouvé:', resourceId);

        if (resourceId) {
          // Chercher la ressource correspondante
          const resourceUrl = `${process.env.VUE_APP_BASEURL}/resourceData/${resourceId}`;
          const resourceResponse = await axios.get(resourceUrl);
          console.log('📡 Réponse API resourceData:', resourceResponse.data);

          if (resourceResponse.data && resourceResponse.data.length > 0) {
            const resource = resourceResponse.data[0];
            console.log('📄 Resource trouvée:', resource);

            // Charger l'image
            const imageUrl = `${process.env.VUE_APP_BASEURL}/s3Resource/${resource.name}`;
            const imageResponse = await axios.get(imageUrl);
            console.log('🖼️ Image chargée, URL length:', imageResponse.data?.length);

            // Appliquer l'image de fond
            popupBackgroundImage.value = imageResponse.data;
            console.log('✅ popupBackgroundImage définie:', !!popupBackgroundImage.value);
          }
        } else {
          console.log('❌ Aucun resourceId trouvé');
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          console.log('Aucune image de fond configurée pour ce point');
        } else {
          console.error('Erreur lors du chargement de l\'image de fond du popup:', error);
        }
      }
    };

    const getPopupBackgroundStyle = computed(() => {
      console.log('🎨 getPopupBackgroundStyle appelée');
      console.log('🖼️ popupBackgroundImage.value:', !!popupBackgroundImage.value, popupBackgroundImage.value?.substring(0, 50) + '...');

      const style = {
        width: '600px',
        height: '320px',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: popupBackgroundColorValue.value || 'white'
      };

      // TODO: Test temporaire avec image hardcodée
      const testMode = false; // Changer à true pour tester

      if (testMode) {
        style.backgroundImage = 'url(https://picsum.photos/800/600)';
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
        style.backgroundRepeat = 'no-repeat';
        console.log('🧪 Mode test avec image hardcodée');
      } else if (popupBackgroundImage.value) {
        style.backgroundImage = `url(${popupBackgroundImage.value})`;
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
        style.backgroundRepeat = 'no-repeat';
        // TODO: Overlay temporairement retiré pour test
        // style.boxShadow = 'inset 0 0 0 2000px rgba(255, 255, 255, 0.3)';
        console.log('✅ Style avec image de fond appliqué (sans overlay pour test)');
      } else {
        style.backgroundImage = 'none';
        console.log('❌ Pas d\'image de fond, style par défaut');
      }

      console.log('🎨 Style final:', style);
      return style;
    });


    watch(() => props.selectedPointId, (newValue) => {
      console.log('selectedPointId changed')
      showPopup(newValue);
    })


    watch(() => pointSelectedFromStore.value, (newValue) => {
      if (newValue && newValue.point_id) {
        showPopup(newValue.point_id);
      }
    });

    const closeDocxViewer = () => {
      docxViewer.value = false;
      blockDocxData.value = null;
    };

    function isDocx(name) {
      if (!name || typeof name !== 'string') return false;
      const extension = name.split('.').pop().toLowerCase();
      return extension === 'docx';
    }

    onMounted(start);
    return {
      exhibitId,
      backgroundImg,
      resources,
      backgroundFile,
      canvasRef,
      navigationPreviewRef,
      mainResourceId,
      imgWidth,
      imgHeight,
      popup,
      negatifSlider,
      blockSliderDatas,
      comicOverlay,
      carousel3D,
      flipBook,
      squareImg,
      points,
      showBlock,
      musicNotes,
      comicsDatas,
      blockCarouselDatas,
      blockScrollDatas,
      scroll,
      homeImage,
      hasHomeImage,
      homeResource,
      video,
      blockVideoDatas,
      animations,
      showBlockDelay,
      hasTitle,
      imageAudio,
      blockImageAudioDatas,
      squareImgData,
      textBlocks,
      start,
      getResources,
      getFile,
      drawImage,
      getPoints,
      showPoints,
      blocksDatas,
      showBlocks,
      blocks1,
      blocks2,
      currentPointId,
      showStyleComponenent,
      closeCarousel3D,
      closeFlipBook,
      isImage,
      isVideo,
      isAudio,
      closeScroll,
      closeAll,
      closeSlider,
      exitHomePage,
      closeVideo,
      getAnimations,
      showAnimations,
      getResourcesFromPoints,
      closeImageAudio,
      getStyle,
      getRotationStyleVideo,
      getTitleStyle,
      getTextBlockStyle,
      docxDatas,
      docxViewer,
      blockDocxData,
      diaporama,
      blockDiaporamaDatas,
      closeDiaporama,
      mosaique,
      blockMosaiqueDatas,
      closeMosaique,
      pellicule,
      blockPelliculeDatas,
      closePellicule,
      coverflow,
      blockCoverflowDatas,
      closeCoverflow,
      avantApres,
      blockAvantApresDatas,
      closeAvantApres,
      closeDocxViewer,
      isDocx,
      loadPopupBackgroundImage,
      getPopupBackgroundStyle
    };
  },
};
</script>
  
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap');

.cartel {
  background-color: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 30px;
  margin-bottom: 30px;
  font-family: 'Roboto', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.6;
  text-align: justify;
  max-width: 500px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.cartel h2 {
  margin-top: 0;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  color: #333;
}

.cartel p {
  margin-bottom: 15px;
}

.cartel a {
  color: #1a73e8;
  text-decoration: none;
  font-weight: 500;
}

.cartel a:hover {
  text-decoration: underline;
}

.mainContainer {
  width: 100%;
  height: 500px;
  position: relative;
}

.popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
}

.navigation-preview {
  width: 100%;
  height: 100%;
}

.navigation-preview--hidden {
  visibility: hidden;
  pointer-events: none;
}

/* Prévisualisation : contenu à taille réelle (1500x800) mis à l'échelle DANS
   une carte de 600x320 (= 1500*0.4 x 800*0.4). transform-origin top-left pour
   un centrage déterministe par Quasar (remplace le hack scale sur le q-dialog). */
.preview-scale-wrap {
  width: 1500px;
  height: 800px;
  transform: scale(0.4);
  transform-origin: top left;
  position: relative;
}

/* Surcharge du style Quasar problématique */
@media (min-width: 600px) {
  .q-dialog__inner--minimized > div {
    max-width: none !important;
  }
}

canvas {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.block {
  position: absolute;
}

.styleElements {
  position: absolute;
  top: 30%;
  z-index: 9999;
}


.img {
  max-width: 100vw;
  border-radius: 10px;
  object-fit: contain;
  display: block;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 2px solid #f0f0f0;
}

.video-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  background-color: #000;
}

home-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f2f2f2;
  /* couleur de fond pour le cas où l'image n'est pas définie */
}

.homeText {
  text-align: center;
  margin-bottom: 30px;
}

.homeText h1 {
  font-size: 36px;
  color: #333;
  /* ajuster la couleur de texte selon les besoins */
  margin: 0;
}

.homeImage {
  width: 100%;
  max-width: 800px;
  /* ajuster la largeur maximale de l'image selon les besoins */
  margin-bottom: 30px;
  margin: auto;
}

.homeImage img {
  display: block;
  width: 80%;
  margin: auto;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.home-arrow {
  font-size: 30px;
  color: #333;
  /* ajuster la couleur de texte selon les besoins */
  cursor: pointer;
  text-align: right;
  margin-right: 50px;
  animation-name: moveArrow;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

@keyframes moveArrow {
  from {
    transform: translateX(-10px);
  }

  to {
    transform: translateX(10px);
  }
}

.associated-resources-icon {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 24px;
  animation: iconPulse 2s ease-in-out infinite;
}

@keyframes iconPulse {
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.8; }
}

.media-container.has-associated {
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.media-container.has-associated:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.spin {
  animation: spin 6s infinite linear !important;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.pulse {
  animation: pulse 1s infinite alternate !important;
}

@keyframes slide {

  0%,
  100% {
    transform: translateX(-100%);
  }

  50% {
    transform: translateX(0);
  }
}

.slide {
  animation: slide 3s infinite !important;
}

@keyframes swingRotate {
  0% {
    transform: rotate(-50deg);
  }

  50% {
    transform: rotate(50deg);
  }

  100% {
    transform: rotate(-50deg);
  }
}

.swingRotate {
  animation: swingRotate 2s ease-in-out infinite;
}

@keyframes verticalBounce {
  0% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-30px);
    /* Modifiez cette valeur pour ajuster l'amplitude */
  }

  100% {
    transform: translateY(0);
  }
}

.verticalBounce {
  animation: verticalBounce 1s ease-in-out infinite;
}
</style>
